<div class="mb-4 p-4 rounded-2xl bg-white shadow-md hover:shadow-lg transition-shadow">
  <div class="flex flex-row gap-8 items-start">
    <!-- Left: Photo Grid (hidden on small screens) -->
    <div class="flex-shrink-0 hidden sm:block">
      <div class="w-64">
        <app-photo-preview [photos]="photos()"></app-photo-preview>
      </div>
    </div>
    <!-- Right: Order Info -->
    <div class="flex-1 min-w-0">
      <div class="text-xs text-gray-500 mb-2">{{ order().lastUpdated.toDate() | date:'medium' }}</div>
      <div class="flex items-center gap-2 mb-4">
        <a 
          class="font-bold text-3xl truncate hover:underline cursor-pointer"
          (click)="navigateToUser($event)"
        >{{ order().userName }}</a>
        @if (statusOption(); as opt) {
          <span class="px-3 py-1 text-xs font-bold rounded-full text-white" [class]="opt.colorClass">{{ opt.label }}</span>
        } @else {
          <span class="px-3 py-1 text-xs font-bold rounded-full bg-gray-400 text-white">{{ order().status }}</span>
        }
      </div>
      <!-- Basic info and totals row -->
      <div class="flex flex-col md:flex-row gap-4 md:gap-8 items-start mb-2">
        <!-- Left: Basic info -->
        <div class="flex flex-col gap-2 w-full md:flex-1 md:min-w-0">
          <app-order-deleted [order]="order()" />
          <app-order-location [order]="order()" />
          <app-order-properties [order]="order()" />
        </div>
        <!-- Right: Number of photos and total price -->
        <div class="flex flex-col items-start md:items-end w-full md:w-auto">
          <div class="font-bold text-3xl truncate">
            {{ ordersService.getTotalPhotos(order()) }} {{ ordersService.getTotalPhotos(order()) === 1 ? 'photo' : 'photos' }}
          </div>
          <div class="font-bold text-3xl truncate mt-2">
            <span class="font-semibold">Price:</span>
            {{ ordersService.calculateTotalPrice(order()) | currency:'EUR':'symbol':'1.2-2':'en-US' }}
          </div>
        </div>
      </div>
      <!-- Action buttons at bottom -->
      <div class="flex justify-between items-center mt-4">
        <button
          class="px-4 py-2 bg-gray-600 text-white rounded-full text-sm hover:bg-gray-700 shadow flex items-center gap-2"
          (click)="openComments()"
        >
          <app-icon name="chat" class="w-4 h-4 text-white" />
          Comments
          @if ((order().comments ?? []).length > 0) {
            <span class="bg-white text-gray-600 px-2 py-0.5 rounded-full text-xs font-semibold">
              {{ (order().comments ?? []).length }}
            </span>
          }
          @if (unseenCommentsCount() > 0) {
            <span class="bg-red-500 text-white px-2 py-0.5 rounded-full text-xs font-semibold">
              {{ unseenCommentsCount() }}
            </span>
          }
        </button>
        <button
          class="px-4 py-2 bg-button-primary text-white rounded-full text-sm hover:bg-button-primary-hover disabled:opacity-50 disabled:cursor-not-allowed shadow"
          (click)="navigateToDetails()"
        >
          Details
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Comments Modal -->
@if (showComments()) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" (click)="closeComments()">
    <div class="w-full max-w-4xl h-[80vh] bg-white rounded-2xl shadow-xl" (click)="$event.stopPropagation()">
      <div class="h-full flex flex-col">
        <!-- Modal Header -->
        <div class="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h2 class="text-3xl font-bold">{{ order().userName }}</h2>
            <p class="text-base text-gray-500">{{ order().size.width }} x {{ order().size.height }}</p>
          </div>
          <button
            (click)="closeComments()"
            class="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Close"
          >
            <app-icon name="close" class="w-6 h-6 text-gray-700" />
          </button>
        </div>
        <!-- Modal Content -->
        <div class="flex-1 overflow-hidden">
          <app-order-comments [order]="order()" />
        </div>
      </div>
    </div>
  </div>
}